module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external "dojo/promise/all"
// module id = 15
// module chunks = 0